import { useState, useCallback, useRef, useEffect } from 'react';
import { usePolling } from '../../../../hooks/usePolling';
import { getERPOracleRequests } from '../../../../api/index';
import { useAuthToken } from '../../../../hooks/AuthHook';

export const useOracleRequests = ({ country, statuses, limit = 5, interval = 5000, isEnabled = true }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const authToken = useAuthToken();
    const hasLoadedRef = useRef(false);

    const fetchRequests = useCallback(async () => {
        if (!authToken || !country) return;

        try {
            // Only set loading on first fetch
            if (!hasLoadedRef.current) setLoading(true);

            const response = await getERPOracleRequests(country, authToken, statuses, limit);
            setData(response);
            setError(null);
        } catch (err) {
            console.error("Error fetching oracle requests:", err);
            setError(err);
        } finally {
            hasLoadedRef.current = true;
            setLoading(false);
        }
    }, [country, authToken, statuses, limit]);

    // Reset state when country or statuses change to trigger fresh loading
    useEffect(() => {
        setData(null);
        hasLoadedRef.current = false;
    }, [country, statuses]);

    usePolling(fetchRequests, interval, isEnabled && !!authToken && !!country, { runOnMount: true });

    return {
        requests: data?.requests || [],
        loading,
        error,
        refetch: fetchRequests
    };
};
